import "./hamburger.css";
import { useEffect, useRef, useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from '@mui/icons-material/Close';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { signOut } from "../../services/userService";
import { useAppSelector } from "../../app/hooks";
import { selectUser } from "../../app/features/usersSlice";
import { useTranslation } from "react-i18next";
import { aboutIcon, contactsIcon } from "./hamburgerIcons";
import BreadcrumbsNavigation from "../Breadcrumbs/BreadcrumbsNavigation";
import { getDesignByPinId } from "../../services/designService";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import Backdrop from '@mui/material/Backdrop';

  const Hamburger = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const user = useAppSelector(selectUser);
  const [menuOpen, setMenuOpen] = useState(false);
  const [breadCrumbsArr, setBreadcrumbsArr]= useState();
  const menuRef = useRef();

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  const buildBrCrArr = async () => {
    const locLen = location.pathname.split('/').length;
    if (location?.pathname === '/') {
      const arr = [
        {link: '/', name: 'Cotown Map', mobileNav: true}, 
      ];
      setBreadcrumbsArr(() => arr);
      return;
    }
    if (locLen === 2) {
      const arr = [
        {link: '/', name: 'Cotown Map', mobileNav: true},
        {link: `/${params?.city}`, name: params?.city, mobileNav: true}
      ];
      setBreadcrumbsArr(() => arr);
    }
    if (locLen === 3) {
      getDesignLocationName(params, locLen);
    }
    if (locLen === 4 || locLen === 5) {
      getDesignLocationName(params, locLen);
    }
  }

  const getDesignLocationName = async (params, len) => {
    const pinInfoRes = await getDesignByPinId(params?.pinID);
    const locationName = pinInfoRes?.pinName;
    const arr = [
      {link: '/', name: 'Cotown Map', mobileNav: true},
      {link: `/${pinInfoRes?.cityName}`, name: pinInfoRes?.cityName, mobileNav: true},
      {link: `/${pinInfoRes?.cityName}/${params?.pinID}`, name: locationName || '', mobileNav: true},
    ];
    // if (len > 3) {
    //   arr.push({link: `/${pinInfoRes?.cityName}/${params?.pinID}`, name: 'Go Back', mobileNav: true})
    // }
    setBreadcrumbsArr(() => arr);
  }

  const openHamburgerMenu = () => {
    setMenuOpen(true);
  }

  useEffect(() => {
    buildBrCrArr();
  }, [location])

  return (
    <div className="hamburger_wrapper">
      <Backdrop 
        open={menuOpen} 
        onClick={() => setMenuOpen(false)}
        style={{zIndex: '1500', width: '100%'}}
        transitionDuration={500}
      ></Backdrop>
      <MenuIcon
        fontSize="large"
        style={{cursor: 'pointer'}}
        className="haburger-menu"
        onClick={openHamburgerMenu}
      />
      <div ref={menuRef} className={"hamburger_content " + (menuOpen ? "open" : "closed")}>
        {menuOpen && 
          <div className="hamburger_close_icon">
            <CloseIcon 
            fontSize="large" 
            className="haburger-menu-close"
            style={{cursor: 'pointer'}}
            onClick={() => setMenuOpen(false)}
            />
          </div>
        }
        <div className="link_wrapper">
          <Link className="burger_links" to="https://cotown.eu/about">
            <span className="hamburger_icon">{aboutIcon}</span>{t('about')}
          </Link>
        </div>

        <div className="link_wrapper">
          <span></span>
          <Link className="burger_links" to="https://cotown.eu/contact">
            <span className="hamburger_icon">{contactsIcon}</span> {t('contact')}
          </Link>
        </div>     
        <div className="horizontal_line_hamburger"></div>
        <BreadcrumbsNavigation
          locations={breadCrumbsArr}
        ></BreadcrumbsNavigation>
        {/* <BreadcrumbsNavigation locations={[{link: '/', name: 'Cotown Map'}, {link: `/${params?.city}`, name: params?.city}]}></BreadcrumbsNavigation> */}
        <div className="horizontal_line_hamburger"></div>
        <div className="lang_switcher_mobile">
          <LanguageSwitcher></LanguageSwitcher>
        </div>
      </div>
    </div>
  );
};

export default Hamburger;
